import React from "react";
import {
    createStyles,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";

type FormErrorWrapperProps = WithStyles<typeof styles> & {
    errors: string[];
    errorMessage: string;
};

const styles = () =>
    createStyles({
        errorMessage: { textAlign: "left" },
        root: { width: "100%" }
    });

class FormErrorWrapper extends React.PureComponent<FormErrorWrapperProps, {}> {
    public render() {
        const classes = this.props.classes;
        const errors = this.props.errors;

        if (!errors || errors.length === 0) {
            return null;
        }

        return (
            <div className={classes.root}>
                <Typography variant="h6" color="error">
                    {this.props.errorMessage}
                </Typography>
                <Typography variant="caption" color="error">
                    <ul>
                        {errors.map((e, idx) => (
                            <li className={classes.errorMessage} key={idx}>
                                {e}
                            </li>
                        ))}
                    </ul>
                </Typography>
            </div>
        );
    }
}

export default withStyles(styles)(FormErrorWrapper);
